import React from 'react'
import Nav from '../../Components/Nav/Nav';
import Footer from '../../Components/Footer/Footer';

function ErrorScreen() {
    return (
        <>
            <Nav />
            <div className='errorScreen'>
                <p>This is the error screen</p>
            </div>
            <Footer />
        </>
    )
}

export default ErrorScreen
